import { Notice, SearchSelect, Select, TextArea } from '@voice/ui';
import { useDirectory } from './common';

export interface Speech {
  audioId?: string | undefined;
  text?: string | undefined;
}

/** Eine Ansage: nichts, ein gesprochener Text oder eine Audiodatei aus der Bibliothek. */
export function SpeechField({ label, value, onChange, hint, variables, example }: { label: string; value: Speech | undefined; onChange: (v: Speech | undefined) => void; hint?: string; variables?: { label: string; token: string }[]; example?: string }) {
  const dir = useDirectory();
  const mode = value?.audioId !== undefined ? 'audio' : value?.text !== undefined ? 'text' : 'none';
  const files = dir.data?.audio ?? [];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <Select
        label={label}
        value={mode}
        hint={hint}
        onChange={(e) => {
          const m = e.target.value;
          if (m === 'none') onChange(undefined);
          else if (m === 'text') onChange({ text: '' });
          else onChange({ audioId: files[0]?.id ?? '' });
        }}
      >
        <option value="none">Keine</option>
        <option value="text">Text sprechen lassen</option>
        <option value="audio">Aufnahme / Datei abspielen</option>
      </Select>
      {mode === 'text' && (
        <>
          <TextArea label="Text" value={value?.text ?? ''} onChange={(e) => onChange({ text: e.target.value })} rows={3} hint={example ? `Beispiel: ${example}` : undefined} />
          {variables && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
              <span style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>Einfügen:</span>
              {variables.map((v) => (
                <button key={v.token} type="button" onClick={() => onChange({ text: `${value?.text ?? ''}${value?.text && !value.text.endsWith(' ') ? ' ' : ''}${v.token}` })} style={{ minHeight: 32, padding: '0 12px', font: 'inherit', fontSize: '0.8125rem', color: 'var(--text-primary)', background: 'transparent', border: '1px solid var(--border-primary)', cursor: 'pointer' }}>
                  {v.label}
                </button>
              ))}
              {example && (
                <button type="button" onClick={() => onChange({ text: example })} style={{ minHeight: 32, padding: '0 12px', font: 'inherit', fontSize: '0.8125rem', color: 'var(--accent-text)', background: 'transparent', border: '1px solid var(--border-primary)', cursor: 'pointer' }}>
                  Beispiel übernehmen
                </button>
              )}
            </div>
          )}
        </>
      )}
      {mode === 'audio' && dir.data && value?.audioId && !files.some((f) => f.id === value.audioId) && <Notice tone="error">Diese Datei gibt es nicht mehr – die Ansage wird übersprungen. Bitte eine andere Datei wählen.</Notice>}
      {mode === 'audio' && (
        <SearchSelect label="Datei" value={value?.audioId ?? ''} onChange={(v) => onChange({ audioId: v })} options={files.map((f) => ({ value: f.id, label: f.name, hint: f.kind === 'music' ? 'Musik' : 'Ansage' }))} placeholder="Datei suchen …" />
      )}
    </div>
  );
}
